module.exports = __webpack_public_path__ + "img/qjb2.17690977.png";